import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SppdashboardService } from 'src/app/view/dashboard/sppdashboard.service';
import Utils from '../utils/utils';
import { FindYourFeeService } from './findyourfee.service';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '../../../src/environments/env';
interface CountryFee {
  code: string;
  name: string;
  fee: number;
}

declare const grecaptcha: any;


@Component({
  selector: 'app-findyourfee',
  templateUrl: './findyourfee.component.html',
  standalone: false,
  styleUrl: './findyourfee.component.scss',
})
export class FindYourFeeComponent implements OnInit {
  //private readonly recaptchaSiteKey = '6LdPxawsAAAAAPJRTx1x_nOZPw2G4vmyBm9mi7tL';
  private readonly minCaptchaScore = 0.5;
  score: number | null = null;
  private isCaptchaRequestInProgress = false;
  captchaErrorMessage: string = '';
  public readonly recaptchaSiteKey = environment.RECAPTCHA_SITE_KEY;
  countryFeeResponse: any;
  activeTab: 'onboarding' | 'testout' = 'testout';
  //@ViewChild('captchaRef') captchaRef: any;
  @ViewChildren('captchaRef') captchaElements!: QueryList<any>;

  private regionalPricing: { [key: string]: number } = {
    US: 100,
    UK: 85,
    CA: 130,
    DE: 95
  };
  // countries: Country[] = [];
  selectedCountry: string = '';
  //currentFee: number = 0;
  amountFee: any;
  currencyFee: any;
  countries: string[] = [];
  // selectedCountry: string = '';
  // currentFee: number = 0;
  currentFormType: string = 'ILT_TRAIN_SUB'; // Default to ILT_TRAIN_SUB
  activeTabIndex: number = 0;

  constructor(private route: ActivatedRoute, private router: Router, private sppdashboardService: SppdashboardService, private utils: Utils, private findyourfeeService: FindYourFeeService, private snackBar: MatSnackBar) { }

  ngOnInit() {
    //localStorage.setItem('prelogin', 'true');

    this.route.queryParams.subscribe(params => {
      if (params['tab'] !== undefined) {
        const targetTab = parseInt(params['tab'], 10);

        // Defer applying the index slightly to allow the lazy-loaded tabs structure to mount smoothly
        setTimeout(() => {
          this.activeTabIndex = targetTab;
        }, 100);
      }
    });


    // setInterval(() => {
    //   this.sppdashboardService.getUser().subscribe((response: any) => {

    //   }, (error: any) => {
    //     if (error.status === 401) {
    //       this.router.navigate(['/authcheck'],{ state: { incomingFromApp: true } });
    //     }
    //   })
    // }, 900000);
    //  this.updateFee();
    this.loadInitialDropdownData();
  }


  // Form Data
  // countries = ['United States', 'United Kingdom', 'Canada', 'India', 'Germany'];
  currencies = ['USD', 'GBP', 'CAD', 'INR', 'EUR'];
  // selectedCountry: string = '';
  selectedCurrency: string = '';

  onBuy() {
    this.router.navigate(['/authcheck'], { state: { incomingFromApp: true } });

    //console.log('button clicked, captchaRef:', this.captchaRef); // ← check this

    // if (!this.captchaRef) {
    //   console.error('captchaRef is undefined!');
    //   return;
    // }

    // this.captchaRef.resolved.subscribe((token: any) => {
    //   console.log('resolved:', token);
    // });

    //  this.captchaRef.error.subscribe((err: any) => {
    //   console.error('reCAPTCHA error:', err);
    // });
    // this.captchaRef.reset();
    //  ///setTimeout(() => {
    //   this.captchaRef.execute();
    // //}, 100);


  }

  onCaptchaResolved(token: string | null) {
    if (!token) {
      //this.captchaErrorMessage = 'Captcha token was empty. Please try again.';
      return;
    }
    // Same validateCaptcha call you already have
    //setTimeout(() => {
    this.validateCaptcha(token);
    //}, 120010);
  }


  validateCaptcha(token: string) {
    this.sppdashboardService.validateCaptcha(token).subscribe({
      next: (response: any) => {
        this.score = response.success || response.data.verified; // Adjust based on your backend response structure
        if (this.score !== null && this.score) {
          this.findyourfeeService.getFeeInfo(this.selectedCountry, this.currentFormType as 'ILT_TRAIN_SUB' | 'TEST_OUT_TRAIN' | 'NEW_MCT_SUB').subscribe({
            next: (res) => {
              //this.currentFee = res.amount;
              this.amountFee = res.feeAmount;
              this.currencyFee = res.currency;
              this.captchaErrorMessage = '';
            },
            // error: (err) => {
            //   this.handleError(err);
            // }
          });
        }
        else {
          this.captchaErrorMessage = 'Verification failed. Please retry.';
        }
        //     if(this.score !== null && this.score){
        //   this.router.navigate(['/authcheck']);
        // }
        // else {
        //     this.captchaErrorMessage = 'Verification failed. Please retry.';
        //   }
      }
    });
  }

  // async onFindFee() {
  //   this.captchaErrorMessage = '';
  //   const action_str = this.utils.generateRandomString();
  //   console.log('Generated random string for reCAPTCHA action:', action_str);

  //   if (this.isCaptchaRequestInProgress) {
  //     return;
  //   }

  //   this.isCaptchaRequestInProgress = true;

  //   try {
  //     let token = await this.executeRecaptcha(action_str);
  //     // Rarely, Google can return an empty token on immediate reuse; retry once.
  //     if (!token) {
  //       token = await this.executeRecaptcha(action_str);
  //     }

  //     if (!token) {
  //       console.error('Captcha token was empty. Please try again.');
  //       this.isCaptchaRequestInProgress = false;
  //       return;
  //     }

  //     console.log('Captcha token:', token);
  //     this.sppdashboardService.validateCaptcha(token).pipe(
  //       finalize(() => {
  //         this.isCaptchaRequestInProgress = false;
  //       })
  //     ).subscribe((response: any) => {
  //       if (response.success) {
  //         console.log('Captcha validated successfully', response);
  //         this.score = response.score;
  //         if (response.score >= this.minCaptchaScore) {
  //           this.findFeeForm();
  //         } else {
  //           this.handleLowCaptchaScore(response.score);
  //         }
  //       } else {
  //         this.captchaErrorMessage = 'Captcha validation failed. Please try again.';
  //         console.error('Captcha validation failed');
  //       }
  //     }, (error: any) => {
  //       this.captchaErrorMessage = 'Unable to validate captcha right now. Please try again.';
  //       console.error('Error validating captcha:', error);
  //     });
  //   } catch (e) {
  //     this.isCaptchaRequestInProgress = false;
  //     this.captchaErrorMessage = 'Unexpected error while validating captcha. Please try again.';
  //     console.error('Unexpected onFindFee error:', e);
  //   }
  // }

  //   private executeRecaptcha(action: string): Promise<string | null> {
  //   return new Promise((resolve) => {

  //     // ✅ Safe check using window — never throws ReferenceError
  //     const grecaptcha = (window as any).grecaptcha;

  //     if (!grecaptcha || 
  //         typeof grecaptcha.ready !== 'function' || 
  //         typeof grecaptcha.execute !== 'function') {
  //       console.error('reCAPTCHA not loaded');
  //       resolve(null);
  //       return;
  //     }

  //     grecaptcha.ready(async () => {
  //       try {
  //         const token = await grecaptcha.execute(this.recaptchaSiteKey, { action });
  //         resolve(token || null);
  //       } catch (error) {
  //         console.error('reCAPTCHA execute error:', error);
  //         resolve(null);
  //       }
  //     });
  //   });
  // }

  private handleLowCaptchaScore(score: number): void {
    this.captchaErrorMessage = 'Verification failed. Please retry the request.';
  }

  findFeeForm() {
    // Implement fee calculation logic here
  }

  // worked

  // onCountryChange(event: any): void {
  //   const countryName = event.target.value;
  //   console.log('Selected Country:', countryName);
  //   this.findyourfeeService.getCountryFee(countryName).subscribe({
  //     next: (response) => {
  //       console.log('API Response:', response);
  //       this.countryFeeResponse = response;
  //     },
  //     error: (error:any) => {
  //       console.error('API Error:', error);
  //     }
  //   });
  // }


  // worked

  // Handle Tab Switch Toggle
  // switchTab(tab: 'onboarding' | 'testout'): void {
  //   this.activeTab = tab;
  // }

  // // Live calculation trigger when selector adjusts
  // updateFee(): void {
  //   this.currentFee = this.regionalPricing[this.selectedCountry] || 100;
  // }

  // // Native OAuth or Profile redirect trigger
  // onSignIn(): void {
  //   console.log('Redirecting to Microsoft authentication workflow...');
  //   // Window routing configuration goes here: window.location.href = 'auth-endpoint';
  // }

  // setActiveTab(tab: 'onboarding' | 'testout'): void {
  //   this.activeTab = tab;
  // }


  // // onCountryChange(): void {
  // //   this.updateFee();
  // // }


  // private updateFee(): void {
  //   const matchedCountry = this.countries.find(c => c.code === this.selectedCountry);
  //   if (matchedCountry) {
  //     this.currentFee = matchedCountry.fee;
  //   }
  // }


  // onTabChange(event: any): void {
  //   // You can hook custom logic here if tab transitions affect state
  //   console.log(`Tab changed to index: ${event.index}`);
  // }

  // updateFee(): void {
  //   const target = this.countries.find(c => c.code === this.selectedCountry);
  //   if (target) {
  //     this.currentFee = target.fee;
  //   }
  // }

  /**
   * Validates token parameters prior to loading dropdown values
   */
  // loadInitialDropdownData(): void {
  //   this.findyourfeeService.getValidToken().pipe(
  //     switchMap(() => this.findyourfeeService.getCountries())
  //   ).subscribe({
  //     next: (data) => {
  //       this.countries = data;
  //       if (this.countries.length > 0) {
  //         // Default to first item from array if available
  //         this.selectedCountry = this.countries[0].countryName;
  //         this.fetchCalculatedFee();
  //       }
  //     },
  //     error: (err) => console.error('Failed to parse countries setup data', err)
  //   });
  // }
  // Inside fee-calculator.component.ts

  // loadInitialDropdownData(): void {
  //   this.findyourfeeService.getCountries().subscribe({
  //     next: (data) => {
  //       this.countries = data;
  //       if (this.countries.length > 0) {
  //         // Set default selected country to the first element string value (e.g., "India")
  //         this.selectedCountry = this.countries[0];
  //         this.fetchCalculatedFee();
  //       }
  //     },
  //     error: (err) => console.error('Failed to parse countries setup data', err)
  //   });
  // }

  // onTabChange(event: MatTabChangeEvent): void {
  //   this.currentFormType = event.index === 0 ? 'NEW_MCT_SUB' : 'TEST_OUT_TRAIN';
  //   this.fetchCalculatedFee();
  // }

  // fetchCalculatedFee(): void {
  //   if (!this.selectedCountry) return;

  //   this.findyourfeeService.getFeeInfo(this.selectedCountry, this.currentFormType).subscribe({
  //     next: (res) => {
  //       this.currentFee = res.amount;
  //     },
  //     error: (err) => console.error('Failed to parse fee data calculations', err)
  //   });
  // }

  loadInitialDropdownData(): void {
    this.findyourfeeService.getCountries().subscribe({
      next: (data) => {
        this.countries = data;
        if (this.countries.length > 0) {
          this.selectedCountry = this.countries[0];
          if (this.score !== null && this.score) {
            this.fetchCalculatedFee();
          }
          // else {
          //   this.captchaErrorMessage = 'Verification failed. Please retry.';
          // }
        }
      },
      // error: (err) => {
      //   this.handleError(err);
      // }
    });
  }

  onTabChange(event: MatTabChangeEvent): void {
    this.currentFormType = event.index === 0 ? 'ILT_TRAIN_SUB' : event.index === 1 ? 'TEST_OUT_TRAIN' : event.index === 2 ? 'NEW_MCT_SUB' : '';
    if (event.index != 3) {
      if (this.score !== null && this.score) {
        this.findyourfeeService.getFeeInfo(this.selectedCountry, this.currentFormType as 'ILT_TRAIN_SUB' | 'TEST_OUT_TRAIN' | 'NEW_MCT_SUB').subscribe({
          next: (res) => {
            //this.currentFee = res.amount;
            this.amountFee = res.feeAmount;
            this.currencyFee = res.currency;
            this.captchaErrorMessage = '';
          },
          // error: (err) => {
          //   //this.handleError(err);
          // }
        });
      }
    }
    // else {
    //       this.captchaErrorMessage = 'Verification failed. Please retry.';
    //     }
    // if(this.score !== null && this.score){
    // this.fetchCalculatedFee();
    // }
    // else {
    //     this.captchaErrorMessage = 'Verification failed. Please retry.';
    //   }
  }

  onCaptchaError(event: any) {
    // console.error('reCAPTCHA Native Internal Error Encountered:', event);
  }

  fetchCalculatedFee(): void {
    //   if (!this.captchaElements || this.captchaElements.length === 0) {
    //   console.warn('QueryList captchaElements is empty.');
    //   return;
    // }

    // // 1. Loop through all instances to find the one that is actually attached to the active DOM tab panel
    // const activeCaptcha = this.captchaElements.toArray().find(captcha => {
    //   const el = captcha?.elementRef?.nativeElement;
    //   return el && el.parentNode && el.getBoundingClientRect().width > 0;
    // });

    setTimeout(() => {
      const activeCaptcha = this.captchaElements ? this.captchaElements.toArray()[0] : null;


      if (!this.selectedCountry) return;


      if (!activeCaptcha) {
        return;
      }

      // activeCaptcha.resolved.subscribe((token: any) => {
      //   console.log('resolved:', token);
      // });

      //  activeCaptcha.error.subscribe((err: any) => {
      //   console.error('reCAPTCHA error:', err);
      // });


      if (!activeCaptcha) {
        return;
      }

      // Standard safe execution loop without heavy nested try/catches
      try {
        activeCaptcha.reset();
        activeCaptcha.execute();
      } catch (error) {
        // console.error('Handled exception during fresh execution loop:', error);
      }
    }, 250);
    //   if(this.score !== null && this.score){
    //   this.findyourfeeService.getFeeInfo(this.selectedCountry, this.currentFormType).subscribe({
    //     next: (res) => {
    //       //this.currentFee = res.amount;
    //       this.amountFee = res.feeAmount;
    //       this.currencyFee = res.currency;
    //     },
    //     error: (err) => {
    //       this.handleError(err);
    //     }
    //   });
    // }
    // else {
    //       this.captchaErrorMessage = 'Verification failed. Please retry.';
    //     }
  }

  /**
   * 4. Centralized method to extract error responses and show the snackbar toast
   */
  private handleError(err: any): void {

    // Fallback message if your API structure changes
    let message = 'An unexpected network error occurred.';

    // Safely extract the custom backend error payload message string
    if (err.error && err.error.message) {
      message = err.error.message;
    } else if (err.message) {
      message = err.message;
    }

    // Trigger Angular Material snackbar panel toast
    this.snackBar.open(message, 'Close', {
      duration: 5000, // Displayed on screen for 5 seconds
      horizontalPosition: 'end', // Right side corner alignment layout
      verticalPosition: 'top', // Top screen alignment positioning rules
      panelClass: ['error-snackbar'] // Custom CSS hooks mapping hooks below
    });
  }
}


/**
 * Triggers calculation workflow safely ensuring token life checks
 */
// fetchCalculatedFee(): void {
//   if (!this.selectedCountry) return;

//   this.findyourfeeService.getValidToken().pipe(
//     switchMap(() => this.findyourfeeService.getFeeInfo(this.selectedCountry, this.currentFormType))
//   ).subscribe({
//     next: (res) => {
//       this.currentFee = res.amount; // Adjust fallback key depending on structural API contracts
//     },
//     error: (err) => console.error('Failed to parse fee data calculations', err)
//   });
// }
// }
